import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_DUPLICATE } from '@/modules/duplicate/router';
import { duplicateService } from '@/services/duplicate';
import { reactive } from 'vue';

export default function () {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        canRemove: false,
        gameLeavePoint: null,
        deckType: null
    });

    const fetch = crudAction.executeAction({
        request: duplicateService.setting.get,
        onSuccess: ({ data }) => {
            model.canRemove = data.canRemove;
            model.gameLeavePoint = data.gameLeavePoint;
            model.deckType = data.deckType;
        },
        onError: () => router.push({ name: ROUTE_NAME_DUPLICATE.ITEM.INDEX })
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            request: () => duplicateService.setting.update(model.deckType, model.gameLeavePoint),
            onFinally: fetch
        }),
        remove: crudAction.confirmAndRemove({
            request: duplicateService.setting.remove,
            onFinally: fetch
        })
    };

    return { model, fetch, actions };
}
